export default __webpack_public_path__ + "static/media/dormammoo2.b9b4387f.jpg";